
import Vue from 'vue';
import { IDictionary } from '~/types';

export default Vue.extend({
	name: 'LocationList',

	mixins: [],

	props: {
		locations: {
			type: Array,
			required: true
		},

		hideQuickNavigation: {
			type: Boolean,
			default: false
		},

		hideHeadingSection: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			existingLetters: [] as string[]
		};
	},

	computed: {
		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		groupedItems() {
			const groups = {} as Record<string, any[]>;
			const currentDomain = this.$getDomain();

			const localeMap = {
				cz: 'cs',
				sk: 'sk',
				hu: 'hu',
				at: 'de',
				de: 'de'
			} as IDictionary<string>;

			const currentLocale = localeMap[currentDomain] || 'de';

			this.locations.forEach((item: any) => {
				const letter = item.name.charAt(0).toUpperCase();
				if (!groups[letter]) {
					groups[letter] = [];
				}
				groups[letter].push(item);
			});

			Object.keys(groups).forEach((letter) => {
				groups[letter].sort((a, b) => {
					const secondA = a.name.charAt(1) || '';
					const secondB = b.name.charAt(1) || '';
					return secondA.localeCompare(secondB, currentLocale);
				});
			});

			const sortedGroups = Object.keys(groups)
				.sort((a, b) => a.localeCompare(b, currentLocale))
				.reduce((result: any, letter: string) => {
					result[letter] = groups[letter];
					return result;
				}, {});

			this.existingLetters = Object.keys(sortedGroups);

			return sortedGroups;
		},

		alphabet() {
			return this.existingLetters || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
		}
	},

	methods: {
		scrollToLetter(letter: string) {
			const ref = this.$refs[`letter-${letter}`];

			let target: Element | null = null;

			if (Array.isArray(ref)) {
				target = (ref[0] as Vue)?.$el || ref[0];
			} else {
				target = (ref as Vue)?.$el || ref;
			}

			if (target) {
				const offset = 80;
				const top = target.getBoundingClientRect().top + window.scrollY - offset;
				window.scrollTo({ top, behavior: 'smooth' });
			}
		}
	}
});
